<template>
  <div class="privacy-page">
    <div class="container">
      <router-link to="/" class="back-home">← Back to Home</router-link>
      <h1>Privacy Agreement</h1>

      <p class="intro">Please read this Privacy Policy carefully as it sets out important information relating to how we handle your personal information. The Playlist Transfer: Music Shift app is an Ad Supported app. This SERVICE is at no cost and is intended for use as is.</p>

      <p>This page is used to inform visitors regarding my policies with the collection, use, and disclosure of Personal Information if anyone decided to use my Service.</p>

      <p>If you choose to use my Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that I collect is used for providing and improving the Service. I will not use or share your information with anyone except as described in this Privacy Policy.</p>

      <p>The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Playlist Transfer: Music Shift unless otherwise defined in this Privacy Policy.</p>

      <h2>Information Collection and Use</h2>
      <p>For a better experience, while using our Service, I may require you to provide us with certain personally identifiable information. The information that I request will be retained on your device and is not collected by me in any way.</p>

      <p>The app does use third party services that may collect information used to identify you.</p>

      <p>Link to privacy policy of third party service providers used by the app:</p>
      <ul>
        <li>Google Play Services</li>
        <li>AdMob</li>
        <li>Firebase Analytics</li>
      </ul>

      <h2>Log Data</h2>
      <p>I want to inform you that whenever you use my Service, in a case of an error in the app I collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol ("IP") address, device name, operating system version, the configuration of the app when utilizing my Service, the time and date of your use of the Service, and other statistics.</p>

      <h2>Cookies</h2>
      <p>Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.</p>
      <p>This Service does not use these "cookies" explicitly. However, the app may use third party code and libraries that use "cookies" to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.</p>

      <h2>Service Providers</h2>
      <p>I may employ third-party companies and individuals due to the following reasons:</p>
      <ul>
        <li>To facilitate our Service;</li>
        <li>To provide the Service on our behalf;</li>
        <li>To perform Service-related services; or</li>
        <li>To assist us in analyzing how our Service is used.</li>
      </ul>
      <p>I want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.</p>

      <h2>Payments</h2>
      <p>Certain Apps may include additional features and services that are subject to payment, the payment can be in terms of an ongoing subscription plans ("Subscription") or one-time payment.</p>
      <p>The Subscription includes different prices or payment terms according to the duration of the applicable Subscription or the type of device you own. Our Subscriptions are pre-paid and you will be charged once at the beginning of each subscription period.</p>
      <p>The Company may offer, at its sole discretion, a free trial for each of the Subscriptions ("Free Trial"). When you sign up for a Free Trial, you acknowledge and agree that unless you actively cancel your Subscription by the end of the Free Trial, you will be automatically billed subject to the then-current terms of the applicable Subscription.</p>
      <p>Once you purchase a Subscription, your subscription will renew automatically and your selected payment method will be charged the applicable fees, unless you actively cancel your Subscription using your App Store or Google Play account.</p>

      <h3>Refunds</h3>
      <p>The Company may issue full or partial refunds for its paid Services depending on the Refunds' reason. The Company Refund policy enable User to issue a Refund Request upon to thirty (30) days of purchase.</p>

      <h3>User Consent for Data Processing Related to Refund Requests</h3>
      <p>In accordance with the App Store's refund policy, when a user initiates a refund request, our server will receive a notification from Apple. In such cases, we will provide Apple with data related to the user's subscription to assist Apple in making a decision regarding the refund request.</p>
      <p>By using this app, you consent to the transmission of your subscription consumption data to Apple, as required for processing refund requests.</p>

      <h2>Security</h2>
      <p>I value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and I cannot guarantee its absolute security.</p>

      <h2>Links to Other Sites</h2>
      <p>This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by me. Therefore, I strongly advise you to review the Privacy Policy of these websites.</p>

      <h2>Children's Privacy</h2>
      <p>These Services do not address anyone under the age of 13. I do not knowingly collect personally identifiable information from children under 13.</p>

      <h2>Changes to This Privacy Policy</h2>
      <p>I may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes.</p>

      <h2>Contact Us</h2>
      <p>If you have any questions or suggestions about my Privacy Policy, do not hesitate to contact me at <a href="mailto:yikenxinxin@gmail.com">yikenxinxin@gmail.com</a></p>

      <p class="document-link">
        Please also review our <router-link to="/terms">Terms &amp; Conditions</router-link>.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
.privacy-page {
  background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%);
  color: #1a1a2e;
  min-height: 100vh;
  padding: 6rem 0;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 24px;
  background: white;
  border-radius: 20px;
  padding: 3rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
}

.back-home {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #3DADFE;
  text-decoration: none;
  font-weight: 600;
  margin-bottom: 2rem;
  transition: color 0.3s;
}

.back-home:hover {
  color: #2b8fd9;
}

h1 {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

h2 {
  font-size: 1.8rem;
  font-weight: 700;
  color: #6366f1;
  margin-top: 3rem;
  margin-bottom: 1rem;
}

h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #8b5cf6;
  margin-top: 2rem;
  margin-bottom: 0.75rem;
}

p {
  line-height: 1.8;
  margin-bottom: 1.5rem;
  color: #4b5563;
}

.intro {
  font-size: 1.1rem;
  color: #6b7280;
}

.document-link {
  margin-top: 2rem;
  font-weight: 600;
}

ul {
  margin-left: 2rem;
  margin-bottom: 1.5rem;
}

li {
  line-height: 1.8;
  color: #4b5563;
  margin-bottom: 0.5rem;
}

a {
  color: #6366f1;
  text-decoration: none;
  transition: color 0.3s;
}

a:hover {
  color: #8b5cf6;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .container {
    padding: 2rem 1.5rem;
  }

  h1 {
    font-size: 2rem;
  }

  h2 {
    font-size: 1.5rem;
  }
}
</style>
